import React, { useState } from "react";

export default function CarouselGallery({ images }) {
  const [current, setCurrent] = useState(0);
  if (!images || images.length === 0) return null;

  const prev = () => setCurrent((current - 1 + images.length) % images.length);
  const next = () => setCurrent((current + 1) % images.length);

  return (
    <div className="carousel-gallery">
      <button onClick={prev}>&lt;</button>
      <img src={images[current]} alt={`Product image ${current + 1}`} style={{ maxWidth: "300px" }} />
      <button onClick={next}>&gt;</button>
      <div className="carousel-indicators">
        {images.map((_, idx) => (
          <span
            key={idx}
            className={idx === current ? "active" : ""}
            onClick={() => setCurrent(idx)}
            style={{ cursor: "pointer", margin: "0 4px" }}
          >
            ●
          </span>
        ))}
      </div>
    </div>
  );
}
